module.exports = __webpack_public_path__ + "img/feature_buy_zh.e780a9dd.png";